import { useFlags } from "launchdarkly-react-client-sdk";
import React, { useCallback, useEffect, useState } from "react";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

const MaintenanceBanner = () => {
  const [open, setOpen] = useState(false);
  const flags = useFlags();
  const {
    maintenance = false,
    text = "",
    title = "",
    severity = "info"
  } = flags.maintenanceBanner || {};

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  useEffect(() => {
    if (maintenance) {
      setOpen(true);
    }
  }, [maintenance]);

  if (!maintenance || !open) {
    return null;
  }

  return (
    <Alert
      severity={severity}
      onClose={handleClose}
      sx={{
        position: "fixed",
        top: "0",
        left: "50%",
        transform: "translate(-50%, 0)",
        zIndex: 1000,
        width: "90%",
        maxWidth: "600px",
        wordWrap: "break-word"
      }}
    >
      <AlertTitle>{title}</AlertTitle>
      {text}
    </Alert>
  );
};

export default MaintenanceBanner;
